import { LatLng } from 'leaflet';

export interface MapCoordinates {
    latitude: number;
    longitude: number;
}

export interface BusLocation extends MapCoordinates {
    device_id: number;
    stop_id?: string;
    at_stop?: boolean;
    bus_speed: number;
    stop_sequence?: number;
    schedule_delay?: number;
    trip_id?: string;
    user_id?: number;
    online?: boolean;
    doors_open?: boolean;
    on_path?: boolean;
    stop_ended?: boolean;
    passengers_onboard?: number;
    distance_to_stop?: number;
    bearing: number;
    routeId?: string;
    timestamp: number;
    engine_running?: boolean;
    region_id: number;
    org_id?: number;
    icon?: {
        color: string;
        textColor: string | null;
        shape: string;
    };
    location_id: string;
    location_type?: string;
    route_short_name?: string;
    direction_id: string;
    expiring_time?: Date;
    latlng?: LatLng;
}

export interface StructuredBusLocation {
    deviceId: string;
    regionId: number;
    locationId: string;
    updateTime: string;
    trip: {
        tripId: string;
        directionId: number;
        routeId?: string;
        routeShortName: string;
        startTime: string;
        startDate: string;
        icon: {
            color: string;
            textColor: string | null;
            shape: string;
        };
    };
    position: {
        speed: number;
        bearing: number;
        latitude: number;
        longitude: number;
    };
}

export interface BusLocationMap {
    [deviceId: number]: BusLocation;
}

export function MapIcons(iconNames: string, env: string = '') {
    if (env) {
        env += '/';
    }
    switch (iconNames) {
        case 'pin':
            return `assets/leaflet/input_pin.png`;
        case 'origin':
            return `assets/leaflet/drop-off.png`;
        case 'bus-stop':
            return `assets/leaflet/bus-stop.png`;
        case 'favorite-stop':
            if (env === 'peutk/' || env === 'tartu/') {
                return `assets/img/explore/favorite-stop.svg`;
            }
            return 'assets/img/explore/bus.svg';

        case 'stop':
            if (env === 'vastmanland/') return `assets/leaflet/${env}icon_stop_bus_default-stop_bus_disabled.svg`;
            return `assets/leaflet/${env}icon_stop_bus_default-stop_bus_disabled.png`;
        case 'stopRetina':
            return `assets/leaflet/${env}icon_stop_bus_default-stop_bus_disabled@2x.png`;
        case 'stopHighlighted':
            if (env === 'vastmanland/') return `assets/leaflet/${env}icon_stop_bus_highlight-stop_bus_default.svg`;
            return `assets/leaflet/${env}icon_stop_bus_highlight-stop_bus_default.png`;
        case 'stopHighlightedRetina':
            return `assets/leaflet/${env}icon_stop_bus_highlight-stop_bus_default@2x.png`;
        case 'stopSelected':
            return `assets/leaflet/${env}icon_stop_bus_selected-stop_bus_default.png`;
        case 'stopSelectedRetina':
            return `assets/leaflet/${env}icon_stop_bus_selected-stop_bus_default@2x.png`;
        case 'circleHuman':
            return `assets/leaflet/${env}icon_person_circle.svg`;
        case 'journeyPlannerOrigin':
            return `assets/leaflet/${env}icon_origin.svg`;
        case 'journeyPlannerDestination':
            return `assets/leaflet/${env}icon_destination.svg`;
        case 'poi':
            if (env === 'vastmanland/') {
                return `assets/img/journey-planner/poi.svg`;
            }
            if (env === 'orebro/' || env === 'varmland/') {
                return `assets/img/explore/poi.svg`;
            }
            return `assets/img/journey-planner/destination.svg`;
        case 'address':
            if (env === 'vastmanland/') {
                return `assets/img/journey-planner/address.svg`;
            }
            return `assets/img/journey-planner/destination.svg`;
    }
}

export interface StopCode {
    stopCode: string;
    updateTime: Date;
    trips: StopCodeTrip[];
    tripsById: { [key: string]: StopCodeTrip };
    allTripsIds: string[];
}

export interface StopCodeTrip {
    extTripId: string;
    directionId: number;
    startTime: string;
    routeShortName: string;
    stopSequence: number;
    arrival: RealTimeAndDelay;
    departure: RealTimeAndDelay;
}

export interface RealTimeAndDelay {
    time: string;
    delay: number;
}

export interface Bus {
    device_id: number;
    latitude: number;
    longitude: number;
    bus_speed: number;
    bearing: number;
    region_id: number;
    location_id: string;
    direction_id: string;
    route_short_name: string;
    routeId?: string;
    timestamp: number;
    trip_id: string;
    expiring_time: string;
}
